export default __webpack_public_path__ + "static/media/wash-iron-round.d58f4c27.png";